<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Incident Cause Form</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <form #form="ngForm" (ngSubmit)="onSubmit()">
    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Cause</mat-label>
      <input
        matInput
        placeholder="Cause"
        [(ngModel)]="incidentCause.name"
        name="name"
        type="text"
        required
        #name
        matTooltip="What happened?" />
      <mat-error *ngIf="!name.valid">Please enter a Cause.</mat-error>
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Type</mat-label>
      <mat-select
        placeholder="Type"
        name="type"
        [(ngModel)]="incidentCause.type"
        required
        #primary
        matTooltip="Was this directly or indirectly the reason for the incident?">
        <mat-option></mat-option>
        <mat-option value="Primary">Primary</mat-option>
        <mat-option value="Secondary">Secondary</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Description</mat-label>
      <textarea
        matInput
        placeholder="Description"
        [(ngModel)]="incidentCause.description"
        name="description"
        rows="4"
        matTooltip="What specifically makes this a cause?"></textarea>
    </mat-form-field>

    <div *ngFor="let action of incidentCause?.actions; let i = index" [ngClass]="{ 'even-action': i % 2 === 0 }">
      <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Corrective Action {{ i + 1 }}</mat-label>
        <input
          matInput
          placeholder="Corrective Action {{ i + 1 }}"
          [(ngModel)]="action.name"
          name="action_{{ i }}"
          required
          matTooltip="What needs to be done to fix this issue?" />

        <button
          type="button"
          matSuffix
          mat-icon-button
          tabindex="-1"
          *ngIf="!action.completed"
          (click)="$event.preventDefault(); $event.stopPropagation()"
          matTooltip="This has not been completed yet">
          <mat-icon>warning</mat-icon>
        </button>

        <button
          type="button"
          matSuffix
          mat-icon-button
          *ngIf="i !== 0"
          (click)="onRemoveAction(i, action)"
          matTooltip="Remove this corrective action.">
          <mat-icon>close</mat-icon>
        </button>

        <mat-error>
          Please enter a Corrective Action.
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Corrective Action Description</mat-label>
        <textarea
          rows="4"
          matInput
          placeholder="Corrective Action Description"
          [(ngModel)]="action.description"
          name="task_description_{{ i }}">
        </textarea>
      </mat-form-field>

      <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Due Date</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          placeholder="Due Date"
          [(ngModel)]="action.due"
          name="due_{{ i }}"
          #due
          readonly
          (click)="picker.open()"/>
        <mat-datepicker-toggle matSuffix [for]="picker"> </mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Priority</mat-label>
        <mat-select
          placeholder="Priority"
          [(ngModel)]="action.priority"
          name="priority_{{ i }}"
          required
          id="priority_{{ i }}">
          <mat-option *ngFor="let priority of priorities" [value]="priority">
            {{priority}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="mb-2" *ngIf="!incidentCause.id">
        <mat-slide-toggle [(ngModel)]="action.individual_actions" name="individual-actions_{{ i }}">
          Create individual tasks for each selected user
        </mat-slide-toggle>
      </div>

      <div class="d-flex justify-content-end flex-wrap mb-0">
        <button
          mat-raised-button
          [matBadge]="action?.user_ids?.length || 0"
          matBadgePosition="before"
          type="button"
          (click)="onSelectUsers(i, action)"
          matTooltip="Select users you want to assign this task to."
          class="my-2 ml-1 mr-2"
          color="secondary">
          <mat-icon>person_pin</mat-icon>
          Select Assignees
        </button>

        <app-file-browse-button
          (selectedFiles)="onSelectFiles(i, $event)"
          (afterDialogClosedEvent)="onSubmit()"
          parentObjectType="action"
          [parentObjectId]="action?.id"
          [filesCount]="action?.files?.length">
        </app-file-browse-button>

      </div>

    </div>

    <mat-error class="mt-3" *ngIf="invalidActions()">
      Please assign people to all Corrective Actions.
    </mat-error>
  </form>

  <div class="mt-3">
    <small>
      <b>Note:</b> Assigned users will be notified to action the tasks that are assigned to them.
    </small>
  </div>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="px-3 py-2">
  <button
    mat-raised-button
    [disabled]="!form.valid || inProgress || !onCanSubmit()"
    color="primary"
    id="save"
    class="my-2 ml-1 mr-2"
    (click)="onSubmit()"
    matTooltip="Save this Cause">
    <mat-icon>save</mat-icon>
    Save
  </button>

  <button
    mat-raised-button
    color="secondary"
    type="button"
    class="my-2 ml-1 mr-2"
    (click)="onAddAction()"
    matTooltip="Add another Action to the list">
    <mat-icon>add</mat-icon>
    Add Corrective Action
  </button>

  <button
    type="button"
    mat-icon-button
    color="warn"
    [disabled]="!incidentCause.id"
    class="dialog-remove-button my-2 ml-auto mr-1"
    (click)="onDelete()"
    matTooltip="Delete this Cause">
    <mat-icon>delete</mat-icon>
  </button>
</mat-dialog-actions>
